
import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ConfirmRegistrationComponent } from './auth/registration/confirm-registration/confirm-registration.component';
import { RegistrationResendValidationComponent } from './auth/registration/registration-resend-validation/registration-resend-validation.component';
import { RegistrationSuccessComponent } from './auth/registration/registration-success/registeration-success.component';
import { RegistrationComponent } from './auth/registration/registration.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { UserEmailChangeConfirmationComponent } from './auth/user-email-change-confirmation/user-email-change-confirmation.component';
import { WelcomePageComponent } from './auth/welcome-page/welcome-page.component';
import { FooterPrivacyComponent } from './footer-links/footer-privacy/footer-privacy.component';
import { FooterTermsComponent } from './footer-links/footer-terms/footer-terms.component';
import { LowerCaseUrlSerializer } from './shared/lower-case-url-serializer';

const appRoutes: Routes = [


    { path: '', redirectTo: '/welcome', pathMatch: 'full' },
    // { path: '/', redirectTo: '/welcome', pathMatch: 'full' },
    {
        path: 'welcome', component: WelcomePageComponent, children: [{ path: 'register/resend', component: RegistrationResendValidationComponent },
        { path: 'register/confirm', component: ConfirmRegistrationComponent }]
    },
    { path: 'login/forgot', component: ForgotPasswordComponent },
    { path: 'login/reset', component: ResetPasswordComponent },
    { path: 'register', component: RegistrationComponent },
    { path: 'register/success', component: RegistrationSuccessComponent },
    { path: 'register/resend', component: RegistrationResendValidationComponent },
    { path: 'register/confirm', component: ConfirmRegistrationComponent },
    { path: 'user/resetemail', component: UserEmailChangeConfirmationComponent },
    {
        path: 'terms', component: FooterTermsComponent,
        data: { isExternalTermsOrPrivacy: true }
    },
    {
        path: 'privacy', component: FooterPrivacyComponent,
        data: { isExternalTermsOrPrivacy: true }
    },
    { path: '**', redirectTo: '/welcome' }

];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
        )
    ],
    providers: [
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        }
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
